module.exports = __webpack_public_path__ + "static/img/sindex_01_010.e6af4d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sindex_01_010.png
// module id = T1wY
// module chunks = 1